import { connect } from "react-redux";
import { startNewGame, toggleEdges, togglePreview, subtractFromTime } from "actions";
import MenuComponent from "~/components/MenuComponent";

const mapStateToProps = state => state;

const mapDispatchToProps = dispatch => ({
  startNewGame: () => {
    dispatch(startNewGame());
  },
  toggleEdges: () => {
    dispatch(toggleEdges());
  },
  togglePreview: () => {
    dispatch(togglePreview());
  },
  subtractFromTime: params => {
    dispatch(subtractFromTime(params));
  }
});

const MenuContainer = connect(mapStateToProps, mapDispatchToProps)(
  MenuComponent
);

export default MenuContainer;



// WEBPACK FOOTER //
// ./src/routes/puzzles/containers/MenuContainer.js